import React from "react";
import PageTransition from "../components/PageTransition";

export default function Settings() {
    return (
        <PageTransition>
            <h2 className="fw-bold mb-0">Settings</h2>
            <div className="text-muted mb-3">System preferences</div>

            <div className="card border-0 shadow-sm">
                <div className="card-body">
                    <div className="fw-semibold">Profile</div>
                    <div className="text-muted small">Add forms here later.</div>
                </div>
            </div>
        </PageTransition>
    );
}
